import request from '@/utils/request'

export function getSystemNoticePageList(data) {
  return request({
    url: '/api/SystemNotice/GetPageList',
    method: 'post',
    data
  })
}

export function getSystemNoticeUnreadCount() {
  return request({
    url: '/api/SystemNotice/GetUnreadCount',
    method: 'get'
  })
}

export function markSystemNoticeAsRead(data) {
  return request({
    url: '/api/SystemNotice/MarkAsRead',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/systemNotice.js